export function scrollChange() {

    window.addEventListener('scroll', function() {
      var elementOur = document.querySelector('.js-change__our');
      var elementContent = document.querySelector('.js-change__content');
      var elementOurTop = elementOur.getBoundingClientRect().top;
      var elementContentTop = elementContent.getBoundingClientRect().top;
      var scrollPosition = window.scrollY;
  
      const HeaderLogo = document.getElementById('js-header__logo');
      const menuBtn = document.getElementById('js-menu_btn');

      if (elementOurTop < 10) {
        menuBtn.classList.add('is-switch');
        HeaderLogo.classList.add('is-switch');
      } else {
        menuBtn.classList.remove('is-switch');
        HeaderLogo.classList.remove('is-switch');
      }

      if (elementContentTop < 10) {
        menuBtn.classList.add('is-switch2');
        HeaderLogo.classList.add('is-switch2');
      } else {
        menuBtn.classList.remove('is-switch2');
        HeaderLogo.classList.remove('is-switch2');
      }
    });
}